import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ClubArtistas() {
  return (
    <>
      <h1 className="text-2xl font-bold mb-4 text-white">ClubArtistas</h1>
      <p className="text-white">
        This is the about page of the application where you can find information
        about the application, its features, and the team behind it.
      </p>
      <div className="mt-4">
        <FontAwesomeIcon
          icon="fa-solid fa-info-circle"
          className="text-3xl text-blue-500"
        />
      </div>
    </>
  );
}
